export default `
    <div class="z-list-box-wrapper #= data.containerClasses || "" #">        
        <div id="#= data.id || "" #" class="z-singular-list-box-container #: data.classes || "" # #=data.bsc||""#" screenentitytype="#= data.ScreenEntityType #" style="#=data.style || ""#">
            # if (data.listBoxLabel) { #
                <label id="ListBoxLabel" class="list-box-label" for="#= data.listBoxId #">#= data.listBoxLabel #</label>
            # } #
            # if (data.searchEnabled) { #
                <span class='k-list-filter' style='margin-right: 25px'><input type='text' id='SearchListBox' class='k-textbox' placeholder='#=data.searchPlaceholder#'/><span class='k-icon k-i-search'></span></span>
            # } #
            <select id="#= data.listBoxId #" class="#=data.listBoxClasses||""#"></select>
        </div>
    </div>
`;
